import type { PaymentSteps } from 'api/models';
import classNames from 'classnames/bind';
import dayjs from 'dayjs';
import { i18nKeys, useTranslation } from 'locales';
import Amount from 'shared/components/Amount';
import type { CurrencyCode } from 'types/currency';

import styleIdentifiers from '../PaymentPlanDetailDebtor.module.scss';

const styles = classNames.bind(styleIdentifiers);

type Props = {
  currency?: CurrencyCode;
  paymentSteps: PaymentSteps[];
};

export default function PaymentStepsDebtor({ paymentSteps, currency }: Props) {
  const { t } = useTranslation();

  const renderStep = (date: any, remainingBalance: any) => (
    <div className={styles('key-text')}>
      <div className={styles('attribute')}>{dayjs(date).format('L')} </div>
      <div className={styles('value')}>
        <Amount localizedValue={remainingBalance} value={remainingBalance} suffix={currency} />
      </div>
    </div>
  );

  return (
    <>
      <h3>{t(i18nKeys.PAYMENT_PLAN.ATTRIBUTES.PAYMENT_STEPS)}</h3>
      {paymentSteps.map(({ attributes: { due_date, remaining_balance } }) => (
        <>{renderStep(due_date, remaining_balance)}</>
      ))}
    </>
  );
}
